(function() {

    let lastClickedEl = null;

    Barba.Dispatcher.on('linkClicked', el => {
        lastClickedEl = el;
    });

    if (document.readyState === 'complete') initBarba();
    else document.onreadystatechange = _ => {
        if (document.readyState === 'complete') initBarba();
    }

    function initBarba() {
        Barba.Pjax.Dom.wrapperId = 'site-wrapper';
        Barba.Pjax.Dom.containerClass = 'site-wrapper__container';
        Barba.Prefetch.init();
        Barba.Pjax.start();
    }

    // Fade transition
    const FadeTransition = Barba.BaseTransition.extend({
        start: function() {
            let fadeOutComplete = false;
            let newContainerLoaded = false;

            vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });

            TweenMax.to(this.oldContainer, 1, { opacity: 0, ease: Power4.easeInOut, onComplete: _ => {
                fadeOutComplete = true;

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

                if (newContainerLoaded) this.finish();
            } });

            this.newContainerLoading.then(_ => {
                TweenMax.set(this.newContainer, { position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, opacity: 0 });
                newContainerLoaded = true;
                if (fadeOutComplete) this.finish();
            });
        },
        finish: function() {
            document.body.scrollTop = 0;

            TweenMax.set(this.newContainer, { position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, opacity: 0 });
            TweenMax.to(this.newContainer, 1, { opacity: 1, ease: Power4.easeInOut, onComplete: _ => { TweenMax.set(this.newContainer, { clearProps: 'all' }) } });

            this.done();
        }
    });

    // Direct transition
    const DirectTransition = Barba.BaseTransition.extend({
        start: function() {
            setTimeout(_ => {
                this.newContainerLoading.then(_ => this.finish());
            }, 1100);
        },
        finish: function() {
            this.done();
        }
    });

    // Topic home transition
    const TopicHomeTransition = Barba.BaseTransition.extend({
        start: function() {
            const slogan = this.oldContainer.querySelector('.jsHeaderSlogan');
            const scrollForMore = this.oldContainer.querySelector('.jsFirstScrollForMore');

            vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });
    
            this.newContainerLoading.then(_ => {
                new TimelineMax({ onComplete: _ => {
                    TweenLite.set(this.newContainer, { clearProps: 'all' });
                    this.done();
                } })
                    // .staggerTo(topicSwitcherElements, 0.2, { x: -10, opacity: 0 }, 0.1)
                    .to(slogan, 0.2, { x: -10, opacity: 0 })
                    .to(scrollForMore, 0.2, { opacity: 0, y: 10 })
                    .set(this.newContainer, { position: 'absolute', visibility: 'visible', top: 0, right: 0, bottom: 0, left: 0, zIndex: 2, opacity: 0 })
                    .to(this.oldContainer, 1, { opacity: 0, ease: Power2.easeInOut })
                    .to(this.newContainer, 1, { opacity: 1, ease: Power2.easeInOut }, '-=1')
                ;
            });
        }
    });

    Barba.Pjax.getTransition = function() {
        const prevUrl = Barba.HistoryManager.prevStatus().url;
        const nextUrl = Barba.HistoryManager.currentStatus().url;

        if (topicHomePages.indexOf(prevUrl) > -1 && topicHomePages.indexOf(nextUrl) > -1) {
            return TopicHomeTransition;
        }

        return FadeTransition;
    };

})();